import axios from "axios";

axios.defaults.baseURL = "https://api.fife.cz/api/";
